"use strict";
import Vue from "vue";
import Theme from "@expressive-analytics/theme-ea-basic";

// load up theme components
import MainNav from "./main-nav.vue";
import Footer from "./footer.vue";
Vue.component("theme-main-nav", MainNav);
Vue.component("theme-footer", Footer);

// pass-through: make the theme's primary object available
export default Theme;
